import * as d3 from "d3";
import { addCommas, genderTooltip, downloadData } from './helpers';
export { raceBarChart };
import * as axios from 'axios';

function raceBarChart() {
    // BAR

    const raceData = axios.get("https://docs.google.com/spreadsheets/d/e/2PACX-1vRb8zyDNZXyPrSgwxUxENm2jKPV-ewDJF_CbEGWvCNuYzXZT_6YwCv209lTeyI6tUIL6jRl6ZWD5Dcv/pub?gid=618758641&single=true&output=csv")
        .then(content => {
            const justData = content.data
            const pop = d3.csvParse(justData)

            const parseDate = d3.timeParse("%Y-%m-%d");

            pop.forEach((d, i) => {
                d.month = parseDate(d.date);
                d.count = +d.value;
            });
            pop.sort((a, b) => b.month - a.month)

            var currdate = pop[0].date

            const data = pop.filter(d => d.date == currdate)

            var racedailymargin = { top: 20, right: 50, bottom: 30, left: 290 },
                racedailywidth = 970 - racedailymargin.left - racedailymargin.right,
                racedailyheight = 500 - racedailymargin.top - racedailymargin.bottom;

            var racedailyy = d3.scaleBand()
                .range([racedailyheight, 0])
                .padding(0.1);

            var racedailyx = d3.scaleLinear()
                .range([0, racedailywidth])

            var racedailysvg = d3.select("#racebarchart").append("svg")
                .attr("width", racedailywidth + racedailymargin.left + racedailymargin.right)
                .attr("height", racedailyheight + racedailymargin.top + racedailymargin.bottom)
                .append("g")
                .attr("transform",
                    "translate(" + racedailymargin.left + "," + racedailymargin.top + ")");

            data.forEach(d => {
                d.value = +d.value;
                if (d.race == "Hispanic") { d.race = "Hispano" }
                else if (d.race == "Black") { d.race = "Afrodescendiente" }
                else if (d.race == "White") { d.race = "Blanco" }
                else if (d.race == "All Others") { d.race = "Todos las otras" }
                else if (d.race == "Chinese") { d.race = "Chino" }
                else if (d.race == "Pacific Islanders") { d.race = "Isleños del pacífico" }
                else if (d.race == "American Indian") { d.race = "Indoamericano" }
                else if (d.race == "Japanese") { d.race = "Japonés" }
            })

            racedailyx.domain([0, d3.max(data, d => d.value)])
            racedailyy.domain(data.map(d => d.race))

            var racedailyxAxis = d3.axisTop(racedailyx).ticks(4)
            var racedailyyAxis = d3.axisLeft(racedailyy)

            racedailysvg.append("g")
                .attr("transform", "translate(0,4)")
                .attr('class', 'x-axis')
                .call(racedailyxAxis)

            racedailysvg.append("g")
                .attr('class', 'y-axis')
                .call(racedailyyAxis)

            racedailyupdate('All')
            function racedailyupdate(gender) {

                let racedailyvariableData;
                if (gender !== 'All') {
                    racedailyvariableData = data.filter(f => f.sex == gender)
                } else {
                    const all = d3.nest()
                        .key(d => d.race)
                        .rollup(v => d3.sum(v, d => d.value))
                        .entries(data)

                    racedailyvariableData = all.map(item => ({
                        race: item.key,
                        value: item.value
                    }));
                }

                const dailyTotal = d3.nest()
                    .key(d => 'd.' + gender)
                    .rollup(v => d3.sum(v, d => d.value))
                    .entries(racedailyvariableData)

                racedailyvariableData.sort((a, b) => a.value - b.value)
                downloadData('data-download-race-bar', racedailyvariableData, 'dailyracedata.csv')

                racedailyx.domain([0, d3.max(racedailyvariableData, d => d.value)]).nice()

                racedailysvg.selectAll(".x-axis").transition().duration(750)
                    .call(racedailyxAxis);

                racedailyy.domain(racedailyvariableData.map(d => d.race))

                racedailysvg.selectAll(".y-axis").transition().duration(750)
                    .call(racedailyyAxis)

                var racedailybar = racedailysvg.selectAll(".bar")
                    .data(racedailyvariableData)

                racedailybar.exit().remove();

                var racedailybarGroup = racedailybar.enter()
                    .append("g")
                    .attr("class", "bar")

                const LACountyPopulation = { 'Hispanic': 48.6, 'Black': 8.1, 'White': 25.9, 'All Others': 7.6, 'Filipino': 3.4, 'Pacific Islanders': 7.6, 'American Indian': .8, 'Japanese': .9 }
                const LACountyRace = Object.keys(LACountyPopulation);
                const LACountyRacePop = Object.values(LACountyPopulation);

                racedailybarGroup.append("rect")
                    .attr("height", racedailyy.bandwidth())
                    .attr("x", d => racedailyx(0))
                    .attr("width", d => racedailyx(d.value))
                    .attr("y", d => racedailyy(d.race))
                    .on("mouseover", function (d) {
                        let countysex
                        if (d.sex == undefined) { countysex = 'individuals' }
                        else { countysex = d.sex }
                        let groupIndex = LACountyRace.indexOf(d.race)

                        var tooltip_str = "<span class='tooltip_percent'>" + ((d.value / dailyTotal[0].value) * 100).toFixed(1) + '%'
                        tooltip.html(tooltip_str)
                            .style("visibility", "visible");
                    })
                    .on("mousemove", function (d) {
                        tooltip.style("top", event.pageY - (tooltip.node().clientHeight + 5) + "px")
                            .style("left", event.pageX - (tooltip.node().clientWidth / 2.0) + "px");
                    })
                    .on("mouseout", function (d) {
                        tooltip.style("visibility", "hidden");
                    })

                racedailybar.select('rect')
                    .transition().duration(750)
                    .attr("x", d => racedailyx(0))
                    .attr("width", d => racedailyx(d.value))
                    .attr("y", d => racedailyy(d.race))

                racedailybarGroup.append("text")
                    .attr("class", "label")
                    .attr("y", d => racedailyy(d.race) + racedailyy.bandwidth() / 2 + 4)
                    .attr("x", d => racedailyx(d.value) + 3)
                    .text(d => addCommas(d.value))

                racedailybar.select("text")
                    .transition()
                    .duration(750)
                    .attr("y", d => racedailyy(d.race) + racedailyy.bandwidth() / 2 + 4)
                    .attr("x", d => racedailyx(d.value) + 3)
                    .text(d => addCommas(d.value))
            }

            d3.selectAll(".genderbuttond").on("click", function () {

                var selectedVariable = d3.select(this).attr("id");
                if (d3.select(this).classed("selected")) {
                } else {
                    d3.selectAll(".genderbuttond").classed("selected", false);
                    d3.select(this).classed("selected", true);
                }
                racedailyupdate(selectedVariable)

            })

        })
    const tooltip = d3.select("body").append("div")
        .attr("class", "tooltip");
}